import { render, staticRenderFns } from "./AdminBaseReviewTests.vue?vue&type=template&id=07b78472"
import script from "./AdminBaseReviewTests.vue?vue&type=script&lang=js"
export * from "./AdminBaseReviewTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports